import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'
import { sharedColors } from './colors'

const footerWrapper = {
  fontSize: fontSizes.medium,
  fontFamily: fonts.sansSerif,
  color: sharedColors.lightGreyText,
  borderTop: `1px solid ${sharedColors.dividerLine}`,
  margin: '0 16px',
}

const footerText = {
  marginLeft: '8px',
}

const footerItem = {
  display: 'flex',
  alignItems: 'center',
  fontWeight: fontWeights.bold,
}

export const sharedStyles = {
  footerWrapper,
  footerText,
  footerItem,
}
